//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faMeSubscription } from '@motionelements/assets/src/js/me-font/icons-channels2022';
import MediaTypeInfoShort from '@motionelements/core/src/components/product-card/sections/ProductCardMediaTypeInfoShortAudio.vue';
import featureFlagMixin from '@motionelements/core/src/components/mixins/feature-flag.mixin.js';

export default {
  name: 'product-card-audio-name',
  components: {
    TextTruncate: () => import('@motionelements/core/src/components/ui/TextTruncate.vue'),
    StemsToggle: () => import('@motionelements/core/src/components/product-card/sections/actions/ProductButtonStemsToggle.vue'),
    MediaTypeInfoShort,
  },
  mixins: [featureFlagMixin],
  inject: {
    isPopUp: {
      default: false,
    },
  },
  props: {
    element: Object,
    showToggle: {
      type: Boolean,
      default: false,
    },
    showPrice: {
      type: Boolean,
      default: true,
    },
    showCategory: {
      type: Boolean,
      default: false,
    },
    showArtistName: {
      type: Boolean,
      default: true,
    },
    //
    reverse: Boolean,
  },
  data() {
    return {
      faMeSubscription,
    };
  },
  computed: {
    linkUrl() {
      return _.get(this.options, 'linkUrl') || this.element.html.url;
    },
    isSubscription() {
      return _.get(this.element, 'subscription');
    },
  },
  methods: {
    handleNameClick(event) {
      if (this.isFeatureEnabled('product_pop-up_modal') && this.isPopUp) {
        event.preventDefault();
        this.$store.commit('product/setCurrentElement', this.element);
        setTimeout(() => {
          this.$bvModal.show('product-pop-up-modal');
        });
      }
    },
  },
};
